import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ClientITProfile, Project } from 'src/app/_models';
import { EvidenceCentralItem } from '../../_models/evidenceCentralItem';
import {AlertService, ClientProfileService} from '../../_services';
import { EditEvidenceCentralComponent } from '../edit-evidence-central/edit-evidence-central.component';
import {EvidenceCentralService} from "../../_services/evidenceCentral.service";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: 'evidence-central',
  templateUrl: './evidence-central.component.html',
  styleUrls: ['./evidence-central.component.css'],
  providers: [DialogService],
})
export class EvidenceCentralComponent implements OnInit, OnDestroy {
  pageTitle;
  @Input() projects: (Project & { itProfiles: ClientITProfile[] })[];

  dialogRef: DynamicDialogRef | undefined;
  evidenceCentralItems: EvidenceCentralItem[] | undefined;

  constructor(
    public dialogService: DialogService,
    public evidenceCentralService: EvidenceCentralService,
    public clientProfileService: ClientProfileService,
    public alertService: AlertService,
  ) {
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['Directives'] || 'Directives');
  }

  ngOnInit(): void {
    this.evidenceCentralService.getAll().subscribe((evidenceCentralItems) => {
      this.evidenceCentralItems = evidenceCentralItems;
      evidenceCentralItems.forEach((item: EvidenceCentralItem) => {
        item.logs.forEach((log) => {
          (<any>log).filteredInspectionResults = (<any>log).inspectionResults.filter(r => r.isSuccess);
        })
      })
    });
  }

  ngOnDestroy(): void {
    this.dialogRef?.close();
  }

  editEvidenceCentralItem(item?: EvidenceCentralItem) {
    const header = `${item ? 'Edit ' : 'Add '} Evidence Central Item${
      item ? ' - ' + item?.name : ''
    }`;

    this.dialogRef = this.dialogService.open(EditEvidenceCentralComponent, {
      width: '80%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      data: {
        item,
        projects: this.projects
      },
      header,
    });

    this.dialogRef.onClose.subscribe((data?: EvidenceCentralItem) => {
      if (!data) {
        return;
      }

      this.alertService.clear();

      if (data.id) {
        this.evidenceCentralService.update(data).subscribe({
          next: (response) => {
            const index = this.evidenceCentralItems.findIndex(
              (i) => i.id === response.id
            );

            response.logs.forEach((log) => {
              (<any>log).filteredInspectionResults = (<any>log).inspectionResults.filter(r => r.isSuccess);
            });

            this.evidenceCentralItems = [
              ...this.evidenceCentralItems.slice(0, index),
              response,
              ...this.evidenceCentralItems.slice(index + 1),
            ];
          },
          error: (error) => {
            this.alertService.error(error?.message ?? error);
          },
        });
      } else {
        this.evidenceCentralService.add(data).subscribe({
          next: (item) => {
            item.logs.forEach((log) => {
              (<any>log).filteredInspectionResults = (<any>log).inspectionResults.filter(r => r.isSuccess);
            });
            this.evidenceCentralItems.push(item);
          },
          error: (error) => {
            this.alertService.error(error?.message ?? error);
          },
        });
      }
    });
  }

  deleteEvidenceCentralItem(item: EvidenceCentralItem) {
    this.evidenceCentralService.delete(item.id).subscribe((i) => {
      this.evidenceCentralItems = this.evidenceCentralItems.filter((i) => i.id !== item.id);
    });
  }

  test(item: EvidenceCentralItem) {
    this.alertService.clear();

    this.evidenceCentralService.test(item).subscribe({
      next: () => {
        this.evidenceCentralService.getById(item.id).subscribe({
          next: (data) => {
            const index = this.evidenceCentralItems.findIndex((i) => i.id === data.id);

            data.logs.forEach((log) => {
              (<any>log).filteredInspectionResults = (<any>log).inspectionResults.filter(r => r.isSuccess);
            });

            this.evidenceCentralItems = [
              ...this.evidenceCentralItems.slice(0, index),
              data,
              ...this.evidenceCentralItems.slice(index + 1),
            ];
          },
          error: (error) => this.alertService.error(error?.message ?? error),
        });
      },
      error: (error) => this.alertService.error(error?.message ?? error),
    });
  }

  format(operator, path, expected, found) {
    switch (operator) {
      case 'Equals':
        return `${path} not equal to ${found}`;
      case 'NotEquals':
        return `${path} equals to ${found}`;
      case 'Contains':
        return `${path} does not contain ${expected}`;
      case 'NotContains':
        return `${path} contains ${expected}`;
      case 'Greater':
        return `${path} is not greater than ${found}`;
      case 'Less':
        return `${path} is not less than ${found}`;
    }
    return '';
  }
}
